import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'emotion-theming'
import { Button, Banner } from 'ascential-horizon'
import getThemeConfig from '../../providers/config/themeConfig'
import {
  InteractionTool,
  Overlay,
  InteractionOverlay,
} from './LivePlayer.style'

const config = {
  label: 'Join the discussion',
}
function SlidoEmbed({ user, url, banner }) {
  const {
    videoPlatform: {
      featuredVideoOverlay: {
        button: { variant },
      },
    },
  } = getThemeConfig()
  const { space } = useTheme()
  const [showIframe, setShowIframe] = useState(false)
  const loggedIn = !!user.loggedIn
  const slidoParams = loggedIn
    ? `?user_name=${encodeURIComponent(
        user.firstName
      )}&user_email=${encodeURIComponent(
        user.email
      )}&user_company=${encodeURIComponent(user.company)}`
    : ''

  const fullUrl = loggedIn ? `${url}/${slidoParams}` : url

  const bannerProps = {
    ...banner,
    mt: space.large,
    textColor: 'light',
    size: 'large',
  }
  function handleClick(e) {
    e.preventDefault()
    setShowIframe(true)
  }
  return (
    <InteractionTool>
      {loggedIn ? (
        <>
          {showIframe ? (
            <iframe
              title="Slido"
              src={fullUrl}
              height="100%"
              width="100%"
              frameBorder="0"
            />
          ) : (
            <InteractionOverlay>
              <Banner {...bannerProps} />
              <Button variant={variant} onClick={handleClick}>
                {config.label}
              </Button>
            </InteractionOverlay>
          )}
        </>
      ) : (
        <Overlay />
      )}
    </InteractionTool>
  )
}

SlidoEmbed.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    company: PropTypes.string,
    loggedIn: PropTypes.bool,
  }),
  url: PropTypes.string.isRequired,
  banner: PropTypes.shape({
    label: PropTypes.string,
  }),
}

SlidoEmbed.defaultProps = {
  user: {},
  banner: null,
}

export default SlidoEmbed
